//libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import RichText from '/react4xp/components/RichText'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
export interface LandingPageHeroProps {
    bgColor?: 'mini' | string
    invertImagePosition?: boolean
    whiteText?: boolean
    title?: string
    image?: {
        src?: string
        srcMedium?: string
        alt?: string
    }
    content?: string
}

export default function LandingPageHero({
    bgColor,
    invertImagePosition,
    whiteText,
    title,
    image,
    content
}: LandingPageHeroProps) {

    // custom bg color
    const customBgColor = bgColor && !['mini'].includes(bgColor) ? { color: bgColor } : {}

    return (
        <>
            <Section
                bgColor={bgColor}
                marginTop='none'
                marginBottom='none'
                className={clsx(
                    'landing-page-hero',
                    bgColor && 'landing-page-hero--has-bg-color'
                )}
            >
                <div className='container'>
                    <div className='row'>

                        {image?.src && (
                            <div className={clsx('col-md-6', !invertImagePosition && 'col-md-push-6')}>
                                <div className='landing-page-hero__image-wrapper'>
                                    <Image
                                        src={image?.src} // 700px x 700px
                                        srcMedium={image?.srcMedium} // 550px x 500px
                                        width={700}
                                        alt={image?.alt}
                                        sizes='
                                            (max-width: 768px) 100vw,
                                            50vw
                                        '
                                        className='cover'
                                    />
                                </div>
                            </div>
                        )}

                        <div className={clsx(
                            'landing-page-hero__texts-wrapper',
                            !invertImagePosition && image?.src ? 'col-md-pull-6' : 'landing-page-hero__texts-wrapper--inverted',
                            image?.src ? 'col-md-6' : 'col-12 landing-page-hero__texts-wrapper--no-image',
                            bgColor != 'mini' && whiteText && 'white'
                        )}>

                            {isNonWhitespaceString(title) && (
                                <h1 className='h1-hero-small line-break'>
                                    {title}
                                </h1>
                            )}

                            {isNonWhitespaceString(content) && (
                                <RichText content={content} />
                            )}

                        </div>

                    </div>

                </div>
            </Section>

            {bgColor && (
                <svg
                    width="1440"
                    height="14"
                    viewBox="0 0 1440 14"
                    className={clsx(
                        'landing-page-hero-divider',
                        bgColor === 'mini' && 'mini'
                    )}
                    xmlns="http://www.w3.org/2000/svg"
                    style={customBgColor}
                >
                    <path d="M1246.57 13.5451C1255.29 13.3297 1440 2.54519 1440 2.54519V0L0 0.000125933L2.22433e-07 2.54532L311.392 13.5452C311.392 13.5452 638.12 1.42504 846.432 2.8297C1003.42 3.88829 1237.84 13.7606 1246.57 13.5451Z" fill="currentColor"/>
                </svg>            
            )}
            
        </>
    )
}